import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getRemainingLeaveWithIn = async (params) => {
    return await api.post("/v1/timePlanShift/getRemainingLeaveWithIn", params);
};


export const getLeaveRequestPaging = async (params) => {
    return await api.post("/v1/leaveRequest/getLeaveRequestPaging", params);
};


export const getMyLeaveRequestCount = async (params) => {
    return await api.post("/v1/leaveRequest/getMyLeaveRequestCount", params);
};
export const getMyLeaveRequestPagingWithoutPending = async (params) => {
    return await api.post("/v1/leaveRequest/getMyLeaveRequestPagingWithoutPending", params);
};

export const getEmployeeGroupByGender = async (params) => {
    return await api.post("/v1/employee/getEmployeeGroupByGender")
}

export const getEmployeeWorkingCountReport = async (params) => {
    return await api.post("/v1/employee/getEmployeeWorkingCountReport", params);
};

export const getEmployeeWorkingDetailReport = async (params) => {
    return await api.post("/v1/employee/getEmployeeWorkingDetailReport", params);
};

export const getSubOrdinateVisaWorkPermitInfo = async (params) => {
    return await api.post("/v1/employee/getSubOrdinateVisaWorkPermitInfo", params);
};